module.exports = __webpack_public_path__ + "static/media/galerija_2013 (21).5396db0d.jpg";